<div class="space-y-6 animate-fade-in-up">

  <!-- FILTER SECTION (PREVIOUSLY DEFINED - REMAINS SAME) -->
  <div class="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
      <div class="flex flex-col gap-1.5">
      <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Firm (Unregistered Only)</label>
      <select [(ngModel)]="filters.firm" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
        <option value="All Firms">All Firms</option>
        <!-- Bind [value] to firm.id so filtering logic is consistent -->
        <option *ngFor="let firm of firmList" [value]="firm.id">
          {{ firm.name }}
        </option>
      </select>
    </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Category</label>
        <select [(ngModel)]="filters.category" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
          <option>All Categories</option>
          <option *ngFor="let cat of categories" [value]="cat">{{cat}}</option>
        </select>
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Date From</label>
        <input type="date" [(ngModel)]="filters.dateFrom" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Date To</label>
        <input type="date" [(ngModel)]="filters.dateTo" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      </div>
      <div class="flex gap-2">
        <button (click)="clearFilters()" class="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-600 font-bold py-2.5 px-3 rounded-lg text-sm transition-colors border border-gray-200">Clear</button>
        <button (click)="applyFilters()" class="flex-1 bg-gradient-to-r from-yellow-700 to-yellow-600 hover:from-yellow-800 hover:to-yellow-700 text-white font-bold py-2.5 px-3 rounded-lg text-sm shadow-md shadow-yellow-500/20 transition-all">Apply</button>
      </div>
    </div>
  </div>

  <!-- SUMMARY CARDS (PREVIOUSLY DEFINED) -->
  <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
    <div class="bg-gradient-to-r from-yellow-600 to-yellow-500 p-6 rounded-2xl shadow-lg text-white">
      <p class="text-[10px] font-bold uppercase tracking-widest opacity-80 mb-2">Total Metal Stock</p>
      <h3 class="text-3xl font-extrabold">{{ summary.totalWeight | number:'1.2-2' }} <span class="text-sm font-medium opacity-80">gms</span></h3>
    </div>
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col justify-between">
      <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Ready Products</p>
      <div class="flex items-center gap-4">
        <div>
          <h3 class="text-2xl font-bold text-gray-800">{{ summary.readyPieceQty | number:'1.0-0' }}</h3>
          <p class="text-[9px] font-bold text-green-600 uppercase">Piece-wise</p>
        </div>
        <div class="w-px h-10 bg-gray-100"></div>
        <div>
          <h3 class="text-2xl font-bold text-gray-800">{{ summary.readyLotQty | number:'1.0-0' }}</h3>
          <p class="text-[9px] font-bold text-blue-600 uppercase">Lot-wise</p>
        </div>
      </div>
    </div>
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">General Products</p>
      <h3 class="text-2xl font-bold text-gray-800">{{ summary.productQty | number:'1.0-0' }} <span class="text-sm text-gray-400 font-normal">items</span></h3>
    </div>
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Assembly WIP</p>
      <h3 class="text-2xl font-bold text-gray-800">{{ summary.assemblyWeight | number:'1.2-2' }} <span class="text-sm text-gray-400 font-normal">gms</span></h3>
    </div>
  </div>

  <!-- DETAILED INVENTORY SECTION -->
  <div class="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
    <div class="flex items-center justify-between mb-8">
        <h3 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
            <span class="w-1.5 h-6 bg-gray-800 rounded-full"></span> Live Stock Inventory (Latest 10)
        </h3>
        <button (click)="goToReport('all')" class="text-xs font-bold text-yellow-700 bg-yellow-50 px-4 py-2 rounded-lg border border-yellow-200 hover:bg-yellow-100 transition-colors flex items-center gap-2">
            View All Stock Report
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
        </button>
    </div>

    <!-- Layout Container -->
    <div class="space-y-10">

        <!-- Piece-wise Section -->
        <div *ngIf="readyPieceItems.length > 0">
            <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-3">
                    <span class="bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded">READY</span>
                    <h4 class="text-xs font-bold text-gray-700 uppercase tracking-widest">Piece-wise Products</h4>
                </div>
                <button (click)="goToReport('piece')" class="text-[10px] font-bold text-gray-500 hover:text-green-600 underline">View Full Piece-wise Report</button>
            </div>
            <div class="overflow-x-auto border border-gray-50 rounded-xl">
                <table class="w-full text-left text-sm">
                    <thead class="bg-gray-50/50 text-[10px] uppercase text-gray-400 font-bold border-b border-gray-100">
                        <tr>
                            <th class="px-6 py-3">Item Detail</th>
                            <th class="px-6 py-3 text-right">Quantity</th>
                            <th class="px-6 py-3 text-right">Total Weight</th>
                            <th class="px-6 py-3 text-right">Item Code</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of readyPieceItems.slice(0, 10)" class="hover:bg-green-50/30 transition-colors group">
                            <td class="px-6 py-4">
                                <span class="font-bold text-gray-700 block">{{ item.st_item_name }}</span>
                                <span class="text-[10px] text-gray-400">{{ item.st_item_category?.name }}</span>
                            </td>
                            <td class="px-6 py-4 text-right font-bold text-green-700">{{ item.st_quantity | number:'1.0-0' }} Pcs</td>
                            <td class="px-6 py-4 text-right font-bold text-gray-800">{{ item.st_total_wt }} {{ item.st_unit || 'gm' }}</td>
                            <td class="px-6 py-4 text-right text-gray-400 text-xs">{{ item.st_item_code }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Lot-wise Section -->
        <div *ngIf="readyLotItems.length > 0">
            <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-3">
                    <span class="bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded">LOT</span>
                    <h4 class="text-xs font-bold text-gray-700 uppercase tracking-widest">Lot-wise Products</h4>
                </div>
                <button (click)="goToReport('lot')" class="text-[10px] font-bold text-gray-500 hover:text-blue-600 underline">View Full Lot-wise Report</button>
            </div>
            <div class="overflow-x-auto border border-gray-50 rounded-xl">
                <table class="w-full text-left text-sm">
                    <thead class="bg-gray-50/50 text-[10px] uppercase text-gray-400 font-bold border-b border-gray-100">
                        <tr>
                            <th class="px-6 py-3">Item Detail</th>
                            <th class="px-6 py-3 text-right">Total Quantity</th>
                            <th class="px-6 py-3 text-right">Total Weight</th>
                            <th class="px-6 py-3 text-right">Item Code</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of readyLotItems.slice(0, 10)" class="hover:bg-blue-50/30 transition-colors">
                            <td class="px-6 py-4">
                                <span class="font-bold text-gray-700 block">{{ item.st_item_name }}</span>
                                <span class="text-[10px] text-gray-400">{{ item.st_item_category?.name }}</span>
                            </td>
                            <td class="px-6 py-4 text-right font-bold text-blue-700">{{ item.st_quantity | number:'1.0-0'  }} Lots</td>
                            <td class="px-6 py-4 text-right font-bold text-gray-800">{{ item.st_total_wt }} {{ item.st_unit || 'gm' }}</td>
                            <td class="px-6 py-4 text-right text-gray-400 text-xs">{{ item.st_item_code }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- General Product Section -->
        <div *ngIf="productItems.length > 0">
            <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-3">
                    <span class="bg-purple-500 text-white text-[10px] font-bold px-2 py-0.5 rounded">PRODUCT</span>
                    <h4 class="text-xs font-bold text-gray-700 uppercase tracking-widest">General Inventory</h4>
                </div>
                <button (click)="goToReport('product')" class="text-[10px] font-bold text-gray-500 hover:text-purple-600 underline">View Product Ledger</button>
            </div>
            <div class="overflow-x-auto border border-gray-50 rounded-xl">
                <table class="w-full text-left text-sm">
                    <thead class="bg-gray-50/50 text-[10px] uppercase text-gray-400 font-bold border-b border-gray-100">
                        <tr>
                            <th class="px-6 py-3">Item Detail</th>
                            <th class="px-6 py-3 text-right">Quantity</th>
                            <th class="px-6 py-3 text-right">Status</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of productItems.slice(0, 10)" class="hover:bg-purple-50/30 transition-colors">
                            <td class="px-6 py-4 font-bold text-gray-700">{{ item.st_item_name }}</td>
                            <td class="px-6 py-4 text-right font-bold text-gray-800">{{ item.st_quantity | number:'1.0-0' }} Pcs</td>
                            <td class="px-6 py-4 text-right">
                                <span class="text-[10px] font-bold bg-purple-50 text-purple-700 px-2 py-1 rounded">In Stock</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Assembly Section -->
        <div *ngIf="assemblyItems.length > 0">
            <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-3">
                    <span class="bg-orange-500 text-white text-[10px] font-bold px-2 py-0.5 rounded">ASSEMBLY</span>
                </div>
                <button (click)="goToReport('assembly')" class="text-[10px] font-bold text-gray-500 hover:text-orange-600 underline">View Assembly Stock</button>
            </div>
            <div class="overflow-x-auto border border-gray-50 rounded-xl">
                <table class="w-full text-left text-sm">
                    <thead class="bg-gray-50/50 text-[10px] uppercase text-gray-400 font-bold border-b border-gray-100">
                        <tr>
                            <th class="px-6 py-3">Material / Job</th>
                            <th class="px-6 py-3 text-right">Weight</th>
                            <th class="px-6 py-3 text-right">Quantity</th>
                            <th class="px-6 py-3 text-right">Supplier/Karigar</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of assemblyItems.slice(0, 10)" class="hover:bg-orange-50/30 transition-colors">
                            <td class="px-6 py-4 font-bold text-gray-700">{{ item.st_item_name }}</td>
                            <td class="px-6 py-4 text-right font-bold text-gray-800">{{ item.st_total_wt | number:'1.0-0' }} GM</td>
                            <td class="px-6 py-4 text-right font-bold text-gray-800">{{ item.st_quantity }} Pcs</td>
                            <td class="px-6 py-4 text-right text-orange-600 font-medium text-xs">{{ item.st_supplier_name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</div>